import { Component, Inject, OnInit } from "@angular/core";
import { MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";
import { DataAlert } from "src/app/interface/data";

@Component({
  selector: "app-snackbar",
  templateUrl: "./snackbar.component.html",
  styleUrls: ["./snackbar.component.scss"],
})
export class SnackbarComponent implements OnInit {
  icon: string;
  type: string;
  title: string;
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: DataAlert) {}

  ngOnInit() {
    this.type = this.data.snackType;
    switch (this.data.snackType) {
      case "success":
        this.icon = "check_circle_outline";
        this.title = "Éxito";
        break;
      case "error":
        this.icon = "error_outline";
        this.title = "Error";
        break;
      case "warn":
        this.icon = "warning";
        this.title = "Advertencia";
        break;
    }
  }

  closeSnackbar() {
    this.data.snackBar.dismiss();
  }
}
